import { getIndexElement } from "../../../../functions/searchInObject"

export class SalesByCustomerRoute{
    constructor(){
        this.Data=[]
        this._map=new Map()
    }

    addCustomer(CustomerNo,CustomerName,Total,Route,Customer){
        if(this._map.has(CustomerNo)){
            this._map.get(CustomerNo).addTotal(Total,Customer)
        }else{
            const entry=new DetailSalesByCustomerRoute(CustomerNo,CustomerName,Total,Route,Customer)
            this._map.set(CustomerNo,entry)
            this.Data.push(entry)
        }
        // sort is deferred to caller after all rows are processed
    }

    finalize(){
        this.Data.sort((a,b)=>b.Total-a.Total)
    }
}

export class DetailSalesByCustomerRoute{
    constructor(CustomerNo,CustomerName,Total,Route,Customer){
        this.Route=Route
        this.CustomerNo=CustomerNo
        this.CustomerName=CustomerName
        this.Total=Number(Total) || 0
        this.TotalNo=1
        this.Detail=[]
        this.Detail.push(Customer)
    }
    addTotal(Total,Customer){
        this.Total+=Number(Total) || 0
        this.TotalNo+=1
        this.Detail.push(Customer)

    }
    
}

export class SalesPerMonth{
    constructor(day,total,totalsales,detail){
        this.day=day
        this.total=total
        this.totalsales=totalsales
        this.detail=detail
    }
}

export class SalesPerWeek{
    constructor(Week){
        this.Week=Week
        this.total=0
        this.totalsales=0
        this.detail=[]
    }

    addInfo(total,totalsales,detail){
        this.total+=total
        this.totalsales+=totalsales
        this.detail=this.detail.concat(detail)
    }


}